import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Dialog, DialogContent, DialogTrigger } from "src/components/ui/dialog";
import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";
import { CarouselDemo } from "src/components/CarouselDemo";
import { getEvent } from "src/api";
import { useQuery } from "@tanstack/react-query";
import ReactPlayer from "react-player";


const GalleryDetail = () => {
    const { id } = useParams();
    const { data: eventsDetails } = useQuery({
        queryKey: ["getEvent", id],
        queryFn: () => getEvent(id),
    });


    // const event = galleryData.find((item) => item.id === parseInt(id));
    // const event = eventsDetails?.data.find((item) => item.id === parseInt(id));

    console.log(eventsDetails?.data);

    const [selectedImage, setSelectedImage] = useState(null);

    // if (!event) {
    //     return <div className="text-center py-20 text-xl">Event not found.</div>;
    // }

    return (
        <div className="relative">
            <Navbar />
            <CarouselDemo />
            <div className="container mx-auto py-[70px]">
                <h1 className="text-3xl font-bold text-center">{eventsDetails?.data?.name}</h1>
                <p className="text-center text-gray-600 mt-2">{eventsDetails?.data?.description}</p>
                {/* Image Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
                    {eventsDetails?.data?.images?.length > 0 ? (
                        eventsDetails?.data?.images.map((image, index) => (
                            <Dialog key={index}>
                                <DialogTrigger asChild>
                                    <img
                                        src={image?.url}
                                        alt={`Gallery ${index}`}
                                        className="w-full h-[400px] object-cover rounded-lg cursor-pointer"
                                        onClick={() => setSelectedImage(image?.url)}
                                    />

                                </DialogTrigger>
                                <DialogContent className="flex flex-col items-center">
                                    <img src={selectedImage} alt="Selected" className="max-w-full h-auto rounded-lg" />
                                </DialogContent>
                            </Dialog>
                        ))
                    ) : (
                        <p className="text-center text-gray-500 col-span-full">No Image Available</p>
                    )}
                </div>
                {eventsDetails?.data?.videos?.length > 0 ? (
                    <>
                        <h2 className="text-center text-gray-600 text-[24px] mt-[100px]">Video(s)</h2>
                        <div className="mt-[50px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
                            {eventsDetails?.data?.videos.map((video, index) => (
                                <div className="w-full">
                                    <ReactPlayer
                                        className="reactplayer-frame"
                                        url={video}
                                        controls="true"
                                        playIcon="true"
                                        config={{
                                            youtube: {
                                                playerVars: { showinfo: 1 }
                                            },
                                            facebook: {
                                                appId: '12345'
                                            }
                                        }}
                                    />
                                </div>
                            ))}

                        </div>
                    </>
                )
                    :
                    ""

                }

            </div>
            <Footer />
        </div>
    );
};

export default GalleryDetail;
